import React, { useCallback } from 'react'
import { useFieldArray } from 'react-hook-form'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { ruleConditions } from './data'

import Condition from '../../Condition'

export default React.memo(
  ({ control, errors, trigger, setValue, getValues }) => {
    const { fields, append, remove } = useFieldArray({
      control,
      name: 'conditions',
      // default keyName is 'id', which overrides and removes our ids
      // before submit, to prevent that we set it to 'key' and
      // let useFieldArray handles it by itself
      keyName: 'key',
    })

    const onAddCondition = useCallback(
      () => {
        const newCondition = {
          operator: null,
          param: null,
          value: '',
        }
        append(newCondition)
      },
      [append]
    )

    const onRemoveCondition = useCallback(
      (condition, index) => {
        remove(index)
      },
      [remove]
    )

    const onConditionChange = useCallback(
      (newCondition, index) => {
        setValue(`conditions.${index}.param`, newCondition.param)
        setValue(`conditions.${index}.operator`, newCondition.operator)
        setValue(`conditions.${index}.value`, newCondition.value)
        trigger(`conditions.${index}`)
      },
      [setValue, trigger]
    )

    return (
      <>
        <div className="grui pt-10">
          {fields.map((item, index) => {
            const values = getValues(`conditions.${index}`)
            return (
              <Condition
                // eslint-disable-next-line react/no-array-index-key
                key={item.key}
                variables={ruleConditions}
                index={index}
                onRemoveCondition={onRemoveCondition}
                conditionErrorMessage={errors && errors[index]?.message}
                conditionId={item.id}
                conditionParam={values.param}
                conditionOperator={values.operator}
                conditionValue={values.value}
                onConditionChange={onConditionChange}
                onInput={onConditionChange}
                decodeIds
                runChangeOnBlur
              />
            )
          })}
        </div>
        <div className="grui mt-10">
          <button
            type="button"
            css={[
              button.styles.link,
              text.styles.textSm,
              text.styles.textPrimary,
            ]}
            onClick={onAddCondition}
          >
            + Add condition
          </button>
        </div>
      </>
    )
  }
)
